import "core-js/modules/es.function.bind";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import Vue from 'vue';
import Router from 'vue-router'; // 引入路由规则

import address from './address';
import authRoutes from './auth';
import checkRoutes from './check';
import createTeamRoutes from './createTeam';
import feedbackRoutes from './feedback';
import rankRoutes from './rank';
import monitorRoutes from './monitor';
import signInRoutes from './signIn';
import userRoutes from './user';
import { routes as user } from '@/modules/user/router';
import activityRoutes from './activity';
import community from './community';
import team from './team';
import shop from './shop';
import contract from './contract';
import extra from './extra';
import market from './market';
import summary from './hundred';
import train from '@/modules/train/router';
import medal from '@/modules/medal/router';
import wish from './wish';
import huangshan from './huangshan';
import intraCity from './intraCity';
import number from './number';
import member from './member';
import internal from './internal';
import plantTree from './plantTree';
import tesla from './tesla';
import afterSale from './afterSale';
import { routes as dream } from '@/modules/dream/router';
import { routes as triangle } from '@/modules/triangle/router';
import { routes as game } from '@/modules/game/router';
import { login, jssdkConfig, setCommonTitle, setTitle, mobileBind, recordReferrer, disableShareHook, setReportData, blockPlatform, checkJoinTeamHint, checkCountdownPopup // checkFirstDayPopup,
, prepareActivityInfo, checkMonitor, teslaRedirect, recordPV, checkChangePackagePopup } from './hook/index';
import lucky from './lucky';
/** V3.1.0版本里面新增功能：push和replace方法会返回一个promise, 修复控制台报错 Uncaught (in promise) */

var originalPush = Router.prototype.push;
var originalReplace = Router.prototype.replace; // @ts-ignore

Router.prototype.push = function push(location, onResolve, onReject) {
  // @ts-ignore
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  } // @ts-ignore


  return originalPush.call(this, location)["catch"](function (err) {
    return err;
  });
}; // @ts-ignore


Router.prototype.replace = function replace(location, onResolve, onReject) {
  // @ts-ignore
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject);
  } // @ts-ignore


  return originalReplace.call(this, location)["catch"](function (err) {
    return err;
  });
};

Vue.use(Router);
var router = new Router({});
router.addRoutes([{
  path: '/word',
  component: function component() {
    return import(
    /* webpackChunkName: "word" */
    '@/pages/word/index.vue');
  }
}]);
router.addRoutes(address); // @ts-ignore

router.addRoutes(authRoutes); // @ts-ignore

router.addRoutes(checkRoutes); // @ts-ignore

router.addRoutes(createTeamRoutes); // @ts-ignore

router.addRoutes(feedbackRoutes); // @ts-ignore

router.addRoutes(rankRoutes); // @ts-ignore

router.addRoutes(monitorRoutes); // @ts-ignore

router.addRoutes(signInRoutes); // @ts-ignore

router.addRoutes(userRoutes); // @ts-ignore

router.addRoutes(activityRoutes);
router.addRoutes(community); // @ts-ignore

router.addRoutes(team); // @ts-ignore

router.addRoutes(shop); // @ts-ignore

router.addRoutes(contract);
router.addRoutes(extra); // @ts-ignore

router.addRoutes(market); // @ts-ignore

router.addRoutes(summary);
router.addRoutes(train);
router.addRoutes(medal); // @ts-ignore

router.addRoutes(wish); // @ts-ignore

router.addRoutes(huangshan); // @ts-ignore

router.addRoutes(intraCity);
router.addRoutes(internal); // @ts-ignore

router.addRoutes(plantTree); // @ts-ignore

router.addRoutes(tesla); // @ts-ignore

router.addRoutes(afterSale);
router.addRoutes(user);
router.addRoutes(dream);
router.addRoutes(triangle);
router.addRoutes(game);
router.addRoutes(number);
router.addRoutes(lucky);
router.addRoutes(member);
router.beforeEach(login.bind(router));
router.beforeEach(teslaRedirect.bind(router));
router.beforeEach(blockPlatform.bind(router));
router.beforeEach(jssdkConfig.bind(router));
router.beforeEach(mobileBind.bind(router));
router.beforeEach(disableShareHook.bind(router));
router.beforeEach(prepareActivityInfo.bind(router));
router.beforeEach(setCommonTitle.bind(router));
router.beforeEach(checkMonitor.bind(router));
router.afterEach(setTitle.bind(router));
router.afterEach(recordReferrer.bind(router));
router.afterEach(recordPV.bind(router));
router.afterEach(setReportData.bind(router)); // router.afterEach(checkFirstDayPopup.bind(router));
// router.afterEach(checkMarketPopup.bind(router));

router.afterEach(checkCountdownPopup.bind(router)); // router.afterEach(checkNormalJoinPopup.bind(router));

router.afterEach(checkJoinTeamHint.bind(router)); // router.afterEach(checkShowGenePopup.bind(router));

router.afterEach(checkChangePackagePopup.bind(router));
export default router;